<template>
  <half-circle-spinner :animation-duration="1000" :size="size" :color="color" />
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'
export default {
  name: 'loder',
  props: {
    color: {
      required: false,
    },

    size: {
      type: Number,
      required: false,
      default: 20,
    },
  },
  components: {
    HalfCircleSpinner,
  },
}
</script>

<style></style>
